import {Component, OnInit} from '@angular/core';
import {PAGES_AND_PATHS} from '../../../../constants/pages-and-paths';
import {ToastrService} from 'ngx-toastr';
import {GrUserExperience} from '../../../../services/http-services/user-experience/user-experience-http-interfaces';
import {UserExperienceHttpService} from '../../../../services/http-services/user-experience/user-experience-http.service';
import {GrPagination} from '../../../../interfaces/general-interfaces';

@Component({
  selector: 'app-user-experiences',
  templateUrl: './user-experiences.component.html'
})
export class UserExperiencesComponent implements OnInit {
  userExperienceForDelete: GrUserExperience | null = null;
  userExperienceForEdit: GrUserExperience | null = null;
  isCreateUserExperienceModalOpen = false;
  userExperiences: GrUserExperience[] = [];
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;

  constructor(private userExperienceHttpService: UserExperienceHttpService,
              private toastService: ToastrService) {
  }
  ngOnInit(): void {
    this.getUserExperience();
  }

  onConfirmCreateOrEditUserExperience(experience: GrUserExperience, isEdit = false): void {
    this.userExperienceForEdit = null;
    this.isCreateUserExperienceModalOpen = false;
    if (isEdit) {
      const indexOfExperience = this.userExperiences.findIndex((element) => element.id === experience.id);
      if (indexOfExperience !== -1) {
        console.log('indexOfExperience', indexOfExperience);
        this.userExperiences.splice(indexOfExperience, 1, experience);
      }
    } else {
      this.userExperiences.unshift(experience);
    }
  }

  getUserExperience(): void {
    this.userExperienceHttpService.getUserExperiences().then((res) => {
      this.userExperiences = res.data;
    });
  }

  onConfirmDeleteUserExperience(): void {
    this.userExperienceHttpService.deleteUserExperience({experienceId: this.userExperienceForDelete?.id}).then((res: any) => {
      this.userExperiences = this.userExperiences.filter(experience => experience.id !== this.userExperienceForDelete?.id);
      this.userExperienceForDelete = null;
      this.toastService.success('Usepšeno ste obrisali recenziju.');
    }).catch(({error}: {error: { errors: { [key: string]: string } }}) => {
      Object.values(error.errors).forEach(error => this.toastService.error(error));
    });
  }
}
